import * as Yup from 'yup'

export const imageManagementSchema = Yup.object({
  title: Yup.string().max(200, 'Title cannot exceed 200 characters'),
  effectiveStartDate: Yup.date().required('Effective start date is required'),
  effectiveEndDate: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .min(Yup.ref('effectiveStartDate'), 'Effective end date must be after start date'),
  active: Yup.boolean().required(),
})
